goog.provide('el8.apphome.docMgr.FileFeedRenderer');

goog.require('el8.uiwidget.FeedRenderer');
goog.require('el8.model.base');


el8.apphome.docMgr.FileFeedRenderer = function(spec) {

    /* Need to store a handle image-related info/objs */
    this._imageSelector = spec.imageSelector; // ImageSelector object
    this._imageWrapSelector = spec.imageWrapSelector; // jQuery selector str

    this._sorterHasIdFn = spec.sorterHasIdFn; // wraps sorter.hasItem
    this._renderEmptyFn = spec.renderEmptyFn;

    el8.uiwidget.FeedRenderer.prototype.constructor.call(this, spec);
};
el8.apphome.docMgr.FileFeedRenderer.inheritsFrom(el8.uiwidget.FeedRenderer);

/**
 * Over-ride the renderEmpty() method because we just want the FileFeed 
 * to self destruct in this case 
 */
el8.apphome.docMgr.FileFeedRenderer.prototype.renderEmpty = function() {
    this._renderEmptyFn.call(this);
};

/**
 * Need to over-ride how the feed refreshes items, because we also have to 
 * manage the image loading inside of them, and make sure locks and image 
 * selection are preserved
 */
el8.apphome.docMgr.FileFeedRenderer.prototype.refreshRenderItem = function(itemId, force) {

    /* Don't do anything if item isn't currently rendered */
    if (!this.isItemRendered(itemId)) { return; }

    /* Don't do anything if can't fetch item */
    var obj = this._feedData.fetchDataById(itemId, force);
    if (!obj) { return; }

    /**
     * If image used to be selected, deselect and then make 
     * sure to select again after image re-rendered
     */
    var $elt = this.getRenderItem(itemId);
    var wasSelected = this._imageSelector._isImageSelected($elt);
    if (wasSelected) {
        this._imageSelector._deselectImage($elt);
    }

    /**
     * Re-implement refreshRenderItem from el8.uiwidget.FeedRenderer, but 
     * with slight twist in terms of how the HTML is rendered. Also, need 
     * to manage updating lock displays
     */
    /**
     * Refresh item in place
     */
    var item = obj['item'];
    var indexedItem = obj['indexedItem'];
    var rendered = $(this._renderItem(item, indexedItem));
    if (rendered.attr('data-lock')) {
        $elt.attr('data-lock', true);
    } else {
        $elt.removeAttr('data-lock');
    }
    $(this._imageWrapSelector, $elt).html(
        $(this._imageWrapSelector, rendered).contents());
    if (this._addlRenderItemFn) { this._addlRenderItemFn($elt, item); }
    //this._updateLockDisplay($elt);

    if (wasSelected && item.isSelectable() && !this._sorterHasIdFn(item.getId())) {
        this._imageSelector._selectImage($elt);
    }

};

